import { useEventListener } from '@vueuse/core'

import { t } from '@/i18n'
import { useToastStore } from '@/platform/updates/common/toastStore'
import { api } from '@/scripts/api'

// interface TaskErrorData {
//   error?: {
//     type: string
//     message: string
//     details?: string
//     extra_info?: any
//   }
//   node_errors?: Record<
//     string,
//     {
//       errors: Array<{
//         type: string
//         message: string
//         details?: string
//         extra_info?: any
//       }>
//       dependent_outputs?: string[]
//       class_type?: string
//     }
//   >
// }

interface TaskErrorMessage {
  type: 'task_error'
  error?: {
    type: string
    message: string
    details?: string
    extra_info?: any
  }
  node_errors?: Record<
    string,
    {
      errors: Array<{
        type: string
        message: string
        details?: string
        extra_info?: any
      }>
      dependent_outputs?: string[]
      class_type?: string
    }
  >
}

export function useTaskErrorNotification() {
  const toastStore = useToastStore()

  console.log('useTaskErrorNotification initialized')
  console.log('API object:', api)
  console.log('Toast store:', toastStore)

  const formatErrorMessage = (errorData: TaskErrorMessage): string => {
    // 如果有节点错误，优先显示节点错误信息
    if (errorData.node_errors) {
      const nodeErrors = Object.entries(errorData.node_errors)
      if (nodeErrors.length > 0) {
        const [, nodeError] = nodeErrors[0]
        const firstError = nodeError.errors[0]

        let message = firstError.message
        if (firstError.details) {
          message += `: ${firstError.details}`
        }

        // 添加节点类型信息
        if (nodeError.class_type) {
          message += ` (${nodeError.class_type})`
        }

        return message
      }
    }

    // 如果没有节点错误，使用通用错误信息
    if (errorData.error) {
      let message = errorData.error.message
      if (errorData.error.details) {
        message += `: ${errorData.error.details}`
      }
      return message
    }

    return t('g.unknownError')
  }

  const handleTaskError = (event: CustomEvent<TaskErrorMessage>) => {
    console.log('Task error event received:', event)
    console.log('Event detail:', event.detail)

    const errorData = event.detail
    const errorMessage = formatErrorMessage(errorData)

    console.log('Formatted error message:', errorMessage)
    console.log('Toast store:', toastStore)

    // 显示错误 toast
    toastStore.add({
      severity: 'error',
      summary: t('g.error'),
      detail: errorMessage,
      life: 8000, // 8秒后自动消失
      closable: true
    })

    console.log('Toast added to store')
    console.error('Task error received:', errorData)
  }

  // 监听 task_error 消息
  const stopListening = useEventListener(api, 'task_error', handleTaskError)

  console.log('Task error listener set up')
  console.log('Stop listening function:', stopListening)

  return {
    stopListening
  }
}
